import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { ServiceItem } from '../models/serviceitem.interface';
import { BaseService } from '../../../../services/framework/base.service'; 

@Injectable({
  providedIn: 'root'
})
export class FeaturesService extends BaseService<FeatureItem>{

  constructor(http: HttpClient, @Inject(OKTA_AUTH) auth: OktaAuth, @Inject('CONFIG_SETTINGS') config: any) {
    super(http, auth);
    const configSettings = config['general'];
    this.apiUrl = configSettings['adminApiUrl'];
    this.apiKey = configSettings['apiKey'];
    this.getEndpoint = 'admindashboard/features';
    this.saveEndpoint = 'admindashboard/features';
    this.removeEndpoint = 'admindashboard/features';
  }
}

export interface FeatureItem extends ServiceItem {
  id: string;
  name?: string;
  description?: string;
  apiUrl?: string;
  isActive?: boolean;
  createdBy?: string;
  updatedBy?: string;
  createdDate?: Date;
  updatedDate?: Date;
}
